{
  "schema": "ft.tree-size-rules.v1",
  "description": "Owner-authorized preservation of authored tree harvesting rules, 2026-09-09. Source IDs remain archived rule records, never catalog choices. Material kinds stay separate. No inferred scaling curve.",
  "profiles": {
    "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F": {
      "name": "Acacia Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "64D49034-A910-4B15-BCDB-E0248D3D2B57",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "797AC4B8-4354-A13C-DAE3-CE6C8CD726A4",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "E889CB31-2B00-C8B9-7935-712C0791B557",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "B909697C-4757-A517-95AB-1F1D1A1A02DA",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "D7674D18-8D71-984D-3277-D3350825C0E2",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "024FD62B-49E7-80E1-5817-3E61D67112B0",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "33383AE2-BCC6-3B45-589A-BD13DE8561F1"
      }
    },
    "4233AB67-7272-4650-AFD4-2C200FEC0D1D": {
      "name": "Ash Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "1950777A-8330-5136-BF4C-A71F2D563764",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "F8072011-1F90-C4E2-96F0-36901D1816D9",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "ED1C3906-8793-A5EE-4C0D-8ACDD022E79F",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "77D70B47-AF77-B2E7-5ACE-94604E024D05",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "AFC907B2-C7B8-0745-7E69-354F5FDCEC58",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "F6BDC521-90B2-DEC9-338A-A60435F5DE7B",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "E9F2191B-9477-4A01-5925-856BE5C87F65"
      }
    },
    "DE3D3E3D-D079-C2F9-24B1-9E5567537014": {
      "name": "Aspen Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "C0382F40-FD01-8BBE-8EE0-BF2DF3FB1B2F",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "6C5F2061-412E-0640-B226-A798E9225297",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "621B4EA6-9539-5A81-3561-8C3EBBD4E3CB",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "67A645A4-1AD8-8161-98F6-10447ECCCA71",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "0A7DCBA2-896F-44E8-C39D-3548481595E8",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "F6871896-AFDD-859D-57B6-A779B09D62D0",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "D7EA614D-DF4E-97C7-401E-C4E219A7E6DF"
      }
    },
    "547567A9-CB9A-B8FD-B27A-A375E6D9CF36": {
      "name": "Azalea Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "C5288A9A-5F78-7AAA-E5B0-ABC38FCFF0E2",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "901FC310-D656-6171-9181-BB9E04B923E0",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "DC28B48F-716B-67D3-3FAD-D17F6078613A",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "3D7A1681-1CF9-DF34-21D6-2495435F8DFB",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "9621AAE0-6F46-5F30-6DAF-D868EBED1BFE",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "9949DC79-90E8-32C1-9E7F-DBC19A199900",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "B4B4C858-470F-5995-8B3D-1CE9D773A16E"
      }
    },
    "3AF7AA77-0EA2-2112-2006-316B4344DAD4": {
      "name": "Baobab Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "74A4267A-6F34-3134-11A9-C0DD868AF26C",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "78AB163A-0C3F-AC1B-ED72-2CCFACAB7D7D",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "44845BA7-56A3-646D-2D19-2681055C4367",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "196C221C-8D0A-E302-B5F6-368D7E6C93B3",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "EA7B42A0-7D2C-33F9-D210-5DB327E6E1F6",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "B689FC00-C375-6124-0C14-096588982CE9",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "8BB0A896-5919-6804-894C-9FE57033B881"
      }
    },
    "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6": {
      "name": "Birch Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "39F69A7C-E219-0B97-C106-2A7EBAED3B87",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "77D9E1CB-7CC8-D511-6689-44AA5F3CC8F2",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "AF2A3D5C-A8A5-A10F-42CC-B145F2669951",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "56A4A7EA-7026-989C-3B57-DA702FBDC850",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "40ABFD60-A859-0D99-53DD-88F726358015",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "136DA7EF-DB04-43B2-0FDD-1B6ECEEE511E",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "A9CCE739-FD4F-93E8-73C8-04878308F7DE"
      }
    },
    "2FE94340-90BB-C04E-B676-30117E55BCC4": {
      "name": "Cedar Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "EEC311A8-95E0-EA8B-73D0-616F420738B4",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "FAF59071-29CA-0322-66EE-2798B9C12BD2",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "1A578F95-DD95-431D-9496-949AEB67890D",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "2FE94340-90BB-C04E-B676-30117E55BCC4",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "1E543785-9245-ADBD-26F2-94A38F810018",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "1CE9B9E9-0A38-9BCD-25C8-68A576886334",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "302AAD8C-5B21-4B7F-D3C7-A1136088049C",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "A0892362-3E16-7B58-E14C-F413658F6840"
      }
    },
    "A17D21A1-3793-1689-3319-AF1B2E076252": {
      "name": "Charred Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "38CEA326-C711-3CC5-0756-255D8062485A",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "3AABD6ED-4195-B141-1C54-EB479F8F8C9F",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "D4FC310D-B88E-D317-DC3D-9D4A7CF02912",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "A17D21A1-3793-1689-3319-AF1B2E076252",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "6E8959F9-4880-B399-72A6-2EEA7B36A534",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "689A7F23-F74F-3550-E050-D1E71BBF3740",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "2DFED77F-6B51-B564-EFA6-44B01B63B334",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "8524A2FA-DFFF-7397-4A1D-220B98254787"
      }
    },
    "236CB0FE-588B-63DD-C316-65C93584989A": {
      "name": "Cherry Blossom Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "97D5F71F-8BC3-BDF4-31AF-F1205B326607",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "B9706B70-E541-FBB8-158F-9609538FB5BF",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "1311F98D-BC21-F794-C88D-F460A491C76B",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "236CB0FE-588B-63DD-C316-65C93584989A",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "7D955A73-3708-6798-1FD1-B4D95250B857",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "49918894-D20D-2D83-8942-75B8FC9BA0C5",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "073EFAF0-4CD4-433C-1EF9-D4634FA93576",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "12D8A1D5-C5A0-0562-78A4-5DAE545EC9B5"
      }
    },
    "C8520FBD-B898-B0C2-A8AB-B4412FFE0465": {
      "name": "Cypress Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "CB4E5EB6-8BDD-A097-6D23-EA1F0E1A15A2",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "AA3C9E27-0A4B-1C11-B1EF-4F5EC64EA6DB",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "BA6D2630-CBD4-1089-E65F-8792E49FE7D8",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "E5D3C223-C2AC-A709-DF5E-1B9C0062FDF5",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "893D1CD0-4DC1-F7E7-C015-79DFDCB5758B",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "391EE28C-1AB4-3E6A-7E4A-819B1DD564C4",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "C60C3044-C042-CC16-1593-4E040BF4B525"
      }
    },
    "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305": {
      "name": "Dark Oak Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "0567C031-5216-BCE6-E15E-7910127EBB18",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "C5CE99AC-33A5-4F93-37E0-D8E17A6F3D62",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "5B71E79F-A4B0-5796-B210-6D3954ACD42D",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "B3C094F8-7D37-B4D1-7A96-AB349DDEFBDF",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "9663621F-434F-2FDC-2B31-55A31F40C687",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "6F3FE128-AC49-3F3E-FE4E-C063A6F78A7E",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "753EC33E-ED05-E888-023D-3B512A74EF58"
      }
    },
    "D5279735-8D79-DE13-1724-10F1F7E6639B": {
      "name": "Fir Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "737DF445-3C62-5C3B-6B42-0CEA17E83D8A",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "4F459C03-1C41-103F-B367-C87BF2D23C75",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "23E14DD8-D732-BAF3-DA4E-C7458858411B",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "D5279735-8D79-DE13-1724-10F1F7E6639B",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "3AABEF07-15DE-4952-7F84-573613ECCC3C",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "F89D0C5C-621F-9421-5C93-D869B88D29DA",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "CA13666C-1651-CF22-765B-7A567C9ACD15",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "B8589F68-9652-5DC7-67B1-A9E16FDE8D31"
      }
    },
    "D77C39E7-69FF-4D4F-63CB-79ED0B269654": {
      "name": "Mangrove Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "8DB2B103-83A5-86E7-5B85-97E3A09097ED",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "40F77D1C-A907-E042-855B-516CF7CEB8A0",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "0B723D62-0FA1-4069-1C8F-99CD9CF67DB6",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "F8AC8A85-D0B4-FB42-066A-C2EFA318BA15",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "161AC263-F7CE-E994-3D4F-95AF0F36621D",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "D4728031-BF9C-387C-982E-EC8E3952EE0A",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "B2F3DF0F-22A0-11D4-A8A8-E5EEC6414A4F"
      }
    },
    "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5": {
      "name": "Maple Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "0D993F09-5EF4-3AC4-0CB3-7FAC784456CB",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "218CF62F-5B68-F708-05AA-EE931B56DD63",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "7EDB1CB2-E37A-17A5-3D9D-8F9B388406DB",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "9EE41322-BF0B-57B0-FE24-D947B9996B50",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "3662BE2B-341C-B6EE-5706-C52691C27BCF",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "E5A92F3C-687A-E0DF-5349-BBD72300917B",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "20EBBB64-214D-EB3D-C795-B997937E9A4B"
      }
    },
    "E721FD00-9169-B5F6-4D77-00B8ECD33CCC": {
      "name": "Nyxthorn Tree",
      "defaultSize": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "BC128733-4BC8-D2B0-8BC5-D1B0A113D7A5",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "3FE0DDB3-5A3D-1AAA-A4D4-57EB85D051C3",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "E37E7C88-22D3-DB6D-30C5-3BC7621B8BE0",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "F32B2712-E9AA-B8F2-CC35-49BDEA7D72C8",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "21F5620C-DCA1-614B-88EE-DDE4B89E2892",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "868E52D5-D3E2-6F5D-5ECF-E4F4E810557F"
      }
    },
    "58287544-C4F2-9996-8B26-73695573238F": {
      "name": "Nyxthorn, Glass",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "58287544-C4F2-9996-8B26-73695573238F"
      }
    },
    "07A1C861-F241-42CE-A80B-D33A0A62ECBA": {
      "name": "Oak Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "4BCEDAC3-7B5D-60C5-194F-58E0BA20E53E",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "78321396-3350-04E3-E1EE-981590880C9E",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "81D1E395-CABB-3103-5785-AC421DC92602",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "90E8727C-CDD2-601B-DE46-D1394FFF0369",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "E75EB9AE-E0B3-A522-CA50-3407492C7030",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "7D45EB2B-E133-E1E5-AED6-D652D9A14F73",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "761F0957-6826-B16B-EA21-BB96452D59F5"
      }
    },
    "F7E884A2-6B7D-3806-C3DE-2A4812927713": {
      "name": "Palm Tree",
      "defaultSize": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C",
      "sourcesBySize": {
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "D1C1AD10-6728-8ECC-7082-1B4963F21BFB",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "9CA67FBB-B316-2B86-D709-578148FDF966",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "6966332B-9503-11DB-C0E2-3DA3F7B5899C",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "44F0CE93-4C63-471C-E98E-ED66DA920341",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "D36AFB6E-5C5D-135C-9CD5-ED719FEB1A89",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "181E804B-E43F-29B3-8B8C-DE4F94B790B5",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "ACD5FB1E-F7C5-AC3C-FCAF-8BA67B2A4135"
      }
    },
    "51D31792-361D-BE06-E1B4-03A1660AAEA1": {
      "name": "Pine Tree",
      "defaultSize": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC",
      "sourcesBySize": {
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "9BAAEF57-48C6-66DD-C711-0D40AABCA2C2",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "7DCE0AD2-D11C-0446-3F4F-7CD53AF28F08",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "A03A96B2-1FDC-241B-8D68-CCA498C53E5E",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "967AF4CD-4450-C7CA-1E87-96E93870B3C0",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "CAD5544D-141E-C4A6-CAEB-2E0FC7092339",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "AD26E4FA-E16C-E934-146F-12BCD00C33BB",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "2FEBAEFE-CCB1-1A19-406E-89BEC9ACBA5A"
      }
    },
    "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440": {
      "name": "Redwood Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "8CAB514F-BD79-1241-F992-D13C8B72E842",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "92BC23E4-7613-3DA6-4DB7-2A518ACAC2C1",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "DC6FADB1-17E3-6E55-9DD1-DEBD15324C92",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "19E5AD59-3CE6-D3BB-A04E-27E0AA547CB3",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "8DD437A7-4A29-362F-5A33-176A69E88FD1",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "D9363633-EA14-7DED-A165-978897CB437B",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "F3454A57-6DE9-0DC4-FE40-F95002A729CF"
      }
    },
    "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0": {
      "name": "Spruce Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "F09BA5EB-6159-4D0C-AE22-00D575CEEDA2",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "4DEC9D2A-BC5C-E87C-9463-6C87AF2919DE",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "07BF7196-0060-62F7-414C-6C4E531D299F",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "02348EBC-A3E2-867C-84ED-C1BC6ADBD51F",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "3D532C66-654F-2684-57D7-08326BC3629E",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "581FE569-262B-9E5E-3332-BECD20A346A0",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "D659F543-CEE5-4561-CE0D-F9DDCE83E738"
      }
    },
    "35B6C53E-0028-4100-BD11-9093C3CF7932": {
      "name": "Willow Tree",
      "defaultSize": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "sourcesBySize": {
        "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68": "622AB4E3-AF63-4692-45D7-F2F2C547F5F1",
        "CEA2946E-D395-46EA-A6E7-74D21EA2376E": "1271D541-EDF2-8B97-F05D-86E7F7EF5BC7",
        "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C": "C8D2E0A4-63AB-CAF8-9108-57229AD7563E",
        "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD": "35B6C53E-0028-4100-BD11-9093C3CF7932",
        "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC": "DC3FFAD4-DFDE-ABA1-BAD7-72F0183A157A",
        "AAC1F466-7A8B-C593-1ADC-FC402B8909D7": "114144A4-45D3-92E7-7498-5A48EE007DF6",
        "13456FEC-A2EE-DB46-5829-0EB2F627E1B7": "9E564724-727E-9EA0-9B3E-9DF13BF10057",
        "4C33FD22-5382-15DA-1C46-F57F14378AFD": "66B765FB-C68C-AD9C-042D-FD9FBEFE84FD"
      }
    }
  },
  "aliases": {
    "64D49034-A910-4B15-BCDB-E0248D3D2B57": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "797AC4B8-4354-A13C-DAE3-CE6C8CD726A4": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "E889CB31-2B00-C8B9-7935-712C0791B557": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "B909697C-4757-A517-95AB-1F1D1A1A02DA": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "D7674D18-8D71-984D-3277-D3350825C0E2": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "024FD62B-49E7-80E1-5817-3E61D67112B0": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "33383AE2-BCC6-3B45-589A-BD13DE8561F1": {
      "itemId": "B91A679D-2542-48BF-7ACE-11B4BCAF0F4F",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "1950777A-8330-5136-BF4C-A71F2D563764": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "F8072011-1F90-C4E2-96F0-36901D1816D9": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "ED1C3906-8793-A5EE-4C0D-8ACDD022E79F": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "77D70B47-AF77-B2E7-5ACE-94604E024D05": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "AFC907B2-C7B8-0745-7E69-354F5FDCEC58": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "F6BDC521-90B2-DEC9-338A-A60435F5DE7B": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "E9F2191B-9477-4A01-5925-856BE5C87F65": {
      "itemId": "4233AB67-7272-4650-AFD4-2C200FEC0D1D",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "C0382F40-FD01-8BBE-8EE0-BF2DF3FB1B2F": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "6C5F2061-412E-0640-B226-A798E9225297": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "621B4EA6-9539-5A81-3561-8C3EBBD4E3CB": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "67A645A4-1AD8-8161-98F6-10447ECCCA71": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "0A7DCBA2-896F-44E8-C39D-3548481595E8": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "F6871896-AFDD-859D-57B6-A779B09D62D0": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "D7EA614D-DF4E-97C7-401E-C4E219A7E6DF": {
      "itemId": "DE3D3E3D-D079-C2F9-24B1-9E5567537014",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "C5288A9A-5F78-7AAA-E5B0-ABC38FCFF0E2": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "901FC310-D656-6171-9181-BB9E04B923E0": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "DC28B48F-716B-67D3-3FAD-D17F6078613A": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "3D7A1681-1CF9-DF34-21D6-2495435F8DFB": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "9621AAE0-6F46-5F30-6DAF-D868EBED1BFE": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "9949DC79-90E8-32C1-9E7F-DBC19A199900": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "B4B4C858-470F-5995-8B3D-1CE9D773A16E": {
      "itemId": "547567A9-CB9A-B8FD-B27A-A375E6D9CF36",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "74A4267A-6F34-3134-11A9-C0DD868AF26C": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "78AB163A-0C3F-AC1B-ED72-2CCFACAB7D7D": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "44845BA7-56A3-646D-2D19-2681055C4367": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "196C221C-8D0A-E302-B5F6-368D7E6C93B3": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "EA7B42A0-7D2C-33F9-D210-5DB327E6E1F6": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "B689FC00-C375-6124-0C14-096588982CE9": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "8BB0A896-5919-6804-894C-9FE57033B881": {
      "itemId": "3AF7AA77-0EA2-2112-2006-316B4344DAD4",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "39F69A7C-E219-0B97-C106-2A7EBAED3B87": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "77D9E1CB-7CC8-D511-6689-44AA5F3CC8F2": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "AF2A3D5C-A8A5-A10F-42CC-B145F2669951": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "56A4A7EA-7026-989C-3B57-DA702FBDC850": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "40ABFD60-A859-0D99-53DD-88F726358015": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "136DA7EF-DB04-43B2-0FDD-1B6ECEEE511E": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "A9CCE739-FD4F-93E8-73C8-04878308F7DE": {
      "itemId": "E90E5E5D-CC9C-22D6-77F5-688A6EE11AD6",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "EEC311A8-95E0-EA8B-73D0-616F420738B4": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "FAF59071-29CA-0322-66EE-2798B9C12BD2": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "1A578F95-DD95-431D-9496-949AEB67890D": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "1E543785-9245-ADBD-26F2-94A38F810018": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "1CE9B9E9-0A38-9BCD-25C8-68A576886334": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "302AAD8C-5B21-4B7F-D3C7-A1136088049C": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "A0892362-3E16-7B58-E14C-F413658F6840": {
      "itemId": "2FE94340-90BB-C04E-B676-30117E55BCC4",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "38CEA326-C711-3CC5-0756-255D8062485A": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "3AABD6ED-4195-B141-1C54-EB479F8F8C9F": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "D4FC310D-B88E-D317-DC3D-9D4A7CF02912": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "6E8959F9-4880-B399-72A6-2EEA7B36A534": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "689A7F23-F74F-3550-E050-D1E71BBF3740": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "2DFED77F-6B51-B564-EFA6-44B01B63B334": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "8524A2FA-DFFF-7397-4A1D-220B98254787": {
      "itemId": "A17D21A1-3793-1689-3319-AF1B2E076252",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "97D5F71F-8BC3-BDF4-31AF-F1205B326607": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "B9706B70-E541-FBB8-158F-9609538FB5BF": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "1311F98D-BC21-F794-C88D-F460A491C76B": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "7D955A73-3708-6798-1FD1-B4D95250B857": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "49918894-D20D-2D83-8942-75B8FC9BA0C5": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "073EFAF0-4CD4-433C-1EF9-D4634FA93576": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "12D8A1D5-C5A0-0562-78A4-5DAE545EC9B5": {
      "itemId": "236CB0FE-588B-63DD-C316-65C93584989A",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "CB4E5EB6-8BDD-A097-6D23-EA1F0E1A15A2": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "AA3C9E27-0A4B-1C11-B1EF-4F5EC64EA6DB": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "BA6D2630-CBD4-1089-E65F-8792E49FE7D8": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "E5D3C223-C2AC-A709-DF5E-1B9C0062FDF5": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "893D1CD0-4DC1-F7E7-C015-79DFDCB5758B": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "391EE28C-1AB4-3E6A-7E4A-819B1DD564C4": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "C60C3044-C042-CC16-1593-4E040BF4B525": {
      "itemId": "C8520FBD-B898-B0C2-A8AB-B4412FFE0465",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "0567C031-5216-BCE6-E15E-7910127EBB18": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "C5CE99AC-33A5-4F93-37E0-D8E17A6F3D62": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "5B71E79F-A4B0-5796-B210-6D3954ACD42D": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "B3C094F8-7D37-B4D1-7A96-AB349DDEFBDF": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "9663621F-434F-2FDC-2B31-55A31F40C687": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "6F3FE128-AC49-3F3E-FE4E-C063A6F78A7E": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "753EC33E-ED05-E888-023D-3B512A74EF58": {
      "itemId": "AF3F40FD-B9B4-491F-B1FD-BE157AC9D305",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "737DF445-3C62-5C3B-6B42-0CEA17E83D8A": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "4F459C03-1C41-103F-B367-C87BF2D23C75": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "23E14DD8-D732-BAF3-DA4E-C7458858411B": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "3AABEF07-15DE-4952-7F84-573613ECCC3C": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "F89D0C5C-621F-9421-5C93-D869B88D29DA": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "CA13666C-1651-CF22-765B-7A567C9ACD15": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "B8589F68-9652-5DC7-67B1-A9E16FDE8D31": {
      "itemId": "D5279735-8D79-DE13-1724-10F1F7E6639B",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "8DB2B103-83A5-86E7-5B85-97E3A09097ED": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "40F77D1C-A907-E042-855B-516CF7CEB8A0": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "0B723D62-0FA1-4069-1C8F-99CD9CF67DB6": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "F8AC8A85-D0B4-FB42-066A-C2EFA318BA15": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "161AC263-F7CE-E994-3D4F-95AF0F36621D": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "D4728031-BF9C-387C-982E-EC8E3952EE0A": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "B2F3DF0F-22A0-11D4-A8A8-E5EEC6414A4F": {
      "itemId": "D77C39E7-69FF-4D4F-63CB-79ED0B269654",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "0D993F09-5EF4-3AC4-0CB3-7FAC784456CB": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "218CF62F-5B68-F708-05AA-EE931B56DD63": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "7EDB1CB2-E37A-17A5-3D9D-8F9B388406DB": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "9EE41322-BF0B-57B0-FE24-D947B9996B50": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "3662BE2B-341C-B6EE-5706-C52691C27BCF": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "E5A92F3C-687A-E0DF-5349-BBD72300917B": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "20EBBB64-214D-EB3D-C795-B997937E9A4B": {
      "itemId": "9B9C1A62-A0CE-2B20-2477-BED5CB71F2B5",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "BC128733-4BC8-D2B0-8BC5-D1B0A113D7A5": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "3FE0DDB3-5A3D-1AAA-A4D4-57EB85D051C3": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "E37E7C88-22D3-DB6D-30C5-3BC7621B8BE0": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "F32B2712-E9AA-B8F2-CC35-49BDEA7D72C8": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "21F5620C-DCA1-614B-88EE-DDE4B89E2892": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "868E52D5-D3E2-6F5D-5ECF-E4F4E810557F": {
      "itemId": "E721FD00-9169-B5F6-4D77-00B8ECD33CCC",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "4BCEDAC3-7B5D-60C5-194F-58E0BA20E53E": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "78321396-3350-04E3-E1EE-981590880C9E": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "81D1E395-CABB-3103-5785-AC421DC92602": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "90E8727C-CDD2-601B-DE46-D1394FFF0369": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "E75EB9AE-E0B3-A522-CA50-3407492C7030": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "7D45EB2B-E133-E1E5-AED6-D652D9A14F73": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "761F0957-6826-B16B-EA21-BB96452D59F5": {
      "itemId": "07A1C861-F241-42CE-A80B-D33A0A62ECBA",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "D1C1AD10-6728-8ECC-7082-1B4963F21BFB": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "9CA67FBB-B316-2B86-D709-578148FDF966": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "6966332B-9503-11DB-C0E2-3DA3F7B5899C": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD"
    },
    "44F0CE93-4C63-471C-E98E-ED66DA920341": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "D36AFB6E-5C5D-135C-9CD5-ED719FEB1A89": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "181E804B-E43F-29B3-8B8C-DE4F94B790B5": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "ACD5FB1E-F7C5-AC3C-FCAF-8BA67B2A4135": {
      "itemId": "F7E884A2-6B7D-3806-C3DE-2A4812927713",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "9BAAEF57-48C6-66DD-C711-0D40AABCA2C2": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "7DCE0AD2-D11C-0446-3F4F-7CD53AF28F08": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "A03A96B2-1FDC-241B-8D68-CCA498C53E5E": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "967AF4CD-4450-C7CA-1E87-96E93870B3C0": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD"
    },
    "CAD5544D-141E-C4A6-CAEB-2E0FC7092339": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "AD26E4FA-E16C-E934-146F-12BCD00C33BB": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "2FEBAEFE-CCB1-1A19-406E-89BEC9ACBA5A": {
      "itemId": "51D31792-361D-BE06-E1B4-03A1660AAEA1",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "8CAB514F-BD79-1241-F992-D13C8B72E842": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "92BC23E4-7613-3DA6-4DB7-2A518ACAC2C1": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "DC6FADB1-17E3-6E55-9DD1-DEBD15324C92": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "19E5AD59-3CE6-D3BB-A04E-27E0AA547CB3": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "8DD437A7-4A29-362F-5A33-176A69E88FD1": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "D9363633-EA14-7DED-A165-978897CB437B": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "F3454A57-6DE9-0DC4-FE40-F95002A729CF": {
      "itemId": "3CA42B2D-EB33-DDF3-634A-8C7B13FA2440",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "F09BA5EB-6159-4D0C-AE22-00D575CEEDA2": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "4DEC9D2A-BC5C-E87C-9463-6C87AF2919DE": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "07BF7196-0060-62F7-414C-6C4E531D299F": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "02348EBC-A3E2-867C-84ED-C1BC6ADBD51F": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "3D532C66-654F-2684-57D7-08326BC3629E": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "581FE569-262B-9E5E-3332-BECD20A346A0": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "D659F543-CEE5-4561-CE0D-F9DDCE83E738": {
      "itemId": "2D9EEB10-7CA4-F45D-0509-C6DC1ACD20B0",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    },
    "622AB4E3-AF63-4692-45D7-F2F2C547F5F1": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68"
    },
    "1271D541-EDF2-8B97-F05D-86E7F7EF5BC7": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "CEA2946E-D395-46EA-A6E7-74D21EA2376E"
    },
    "C8D2E0A4-63AB-CAF8-9108-57229AD7563E": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C"
    },
    "DC3FFAD4-DFDE-ABA1-BAD7-72F0183A157A": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC"
    },
    "114144A4-45D3-92E7-7498-5A48EE007DF6": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7"
    },
    "9E564724-727E-9EA0-9B3E-9DF13BF10057": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7"
    },
    "66B765FB-C68C-AD9C-042D-FD9FBEFE84FD": {
      "itemId": "35B6C53E-0028-4100-BD11-9093C3CF7932",
      "sizeId": "4C33FD22-5382-15DA-1C46-F57F14378AFD"
    }
  }
}
